import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faPrescriptionBottle, faHistory, faCalendarAlt, faUserMd, faCalendarCheck, faFlag, faBars } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import './Responsive.css'; // Import the new responsive CSS
import { isAdmin, isDoctor } from './helper/authRoles';

function Sidebar() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      {/* Hamburger menu icon */}
      <FontAwesomeIcon
        icon={faBars}
        className="hamburger-menu"
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <div className={`dashboard-sidebar ${isSidebarOpen ? 'active' : ''}`}>
        <ul>
          <li className={location.pathname === '/dashboard'|| location.pathname.startsWith('/dashboard') ? 'active-menu' : ''}>
            <Link to="/dashboard">
              <FontAwesomeIcon icon={faTachometerAlt} />
              <span>Dashboard</span>
            </Link>
          </li>
          {isDoctor() && (
            <li className={location.pathname === '/create-prescription' || location.pathname.startsWith('/create-prescription') ? 'active-menu' : ''}>
              <Link to="/create-prescription">
                <FontAwesomeIcon icon={faPrescriptionBottle} />
                <span>Create Prescription</span>
              </Link>
            </li>
          )}
          {isAdmin() && (
            <li className={location.pathname === '/doctor-history' || location.pathname.startsWith('/doctor-history') ? 'active-menu' : ''}>
              <Link to="/doctor-history">
                <FontAwesomeIcon icon={faUserMd} />
                <span>Doctor</span>
              </Link>
            </li>
          )}
          {isAdmin() && (
            <li className={location.pathname === '/appoinment-history' || location.pathname.startsWith('/appoinment-history') ? 'active-menu' : ''}>
              <Link to="/appoinment-history">
                <FontAwesomeIcon icon={faCalendarCheck} />
                <span>Appointment</span>
              </Link>
            </li>
          )}
          <li className={location.pathname === '/patient-history' || location.pathname.startsWith('/patient-history') ? 'active-menu' : ''}>
            <Link to="/patient-history">
              <FontAwesomeIcon icon={faHistory} />
              <span>Patient History</span>
            </Link>
          </li>
          {isDoctor() && (
            <li className={location.pathname === '/appoinment-history' || location.pathname.startsWith('/appoinment-history') ? 'active-menu' : ''}>
              <Link to="/appoinment-history">
                <FontAwesomeIcon icon={faCalendarCheck} />
                <span>My Appointment</span>
              </Link>
            </li>
          )}
          {isAdmin() && (
            <li className={location.pathname === '/report' || location.pathname.startsWith('/report') ? 'active-menu' : ''}>
              <Link to="/report">
                <FontAwesomeIcon icon={faFlag} />
                <span>Report</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
